import { baseState, baseMutations } from '@/store/mixins'
import httpClient from '@/http-client'

const BASE_URL = '/api//v2/single-copy-scores'

export default {
  namespaced: true,
  state: {
    ...baseState,
    loading: false,
  },
  mutations: {
    ...baseMutations,
    SET_LOADING(state, loading) {
      state.loading = loading
    },
  },
  actions: {
    formViewModel(context, params = {}) {
      return httpClient.get(`${BASE_URL}/form-view-models`, { params })
    },
    store(context, data) {
      return httpClient.post(`${BASE_URL}`, data)
    }
  }
}
